<div style="min-height: 250px;">
  <ckeditor [editor]="Editor" [(ngModel)]="module.settings.content.text" [config]="editorConfig"></ckeditor>
</div>